import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaskListRoutingModule } from './task-list-routing.module';
import { TaskListComponent } from './task-list.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxToolbarModule, DxAccordionModule, DxNumberBoxModule, DxGanttModule, DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxDropDownButtonModule, DxPopupModule, DxRangeSliderModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule } from 'devextreme-angular';
import dxTextBox from 'devextreme/ui/text_box';
import { CreateUpdateTaskModule } from '../create-update-task/create-update-task.module';
import { SharedDatagridModule } from '../shared-datagrid/shared-datagrid.module';
import { MemorizedTaskModule } from '../memorized-task/memorized-task.module';


@NgModule({
  declarations: [
    TaskListComponent
  ],
  imports: [
    CommonModule,
    // TaskListRoutingModule,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxNumberBoxModule,
    DxSliderModule,
    DxDropDownButtonModule,
    CreateUpdateTaskModule,
    DxTextAreaModule,
    MemorizedTaskModule,
    SharedDatagridModule,
    DxGanttModule,
    DxToolbarModule
  ],
  exports: [
    TaskListComponent,
    MdbGlobalModule,
    DxAccordionModule,
    DxButtonModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxRangeSliderModule,
    DxTemplateModule
  ],
  schemas: [NO_ERRORS_SCHEMA]

})
export class TaskListModule { }
